import {
  takeEvery, put, call,
} from "redux-saga/effects";

import { GET_EVENTS_START } from "./actionTypes";
import { fetchEventsEnd } from "./actions";
import * as eventsApi from "../../apis/events";
import { showErrorNotification } from "store/notifications/actions";

function* fetchEvents(params) {
  try {
    const data = yield call(eventsApi.getEvents, params);
    yield put(fetchEventsEnd({ data }));
  } catch (error) {
    yield put(fetchEventsEnd({ error }));
    yield put(showErrorNotification(error.message));
  }
}

function* eventsSaga() {
  yield takeEvery(GET_EVENTS_START, fetchEvents);
}

export default eventsSaga;
